/**
 * AI commentary cue — inside the "Passage to Study" card. Tells the study
 * creator an AI pericope commentary is available for their passage, and runs
 * the same flow as the reader's pericope popover button. Once attached,
 * shows the state and offers removal (the commentary is optional — a study
 * prints fine without it).
 */

import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { SparklesIcon, CloseIcon } from '@components/icons';

export const AiCommentaryCue = observer(() => {
  const study = bibleState.editingStudy;
  if (!study) return null;

  if (study.aiCommentary) {
    return (
      <div className="ai-commentary-cue-attached" data-testid="ai-commentary-attached">
        <SparklesIcon className="h-4 w-4 shrink-0 text-cyan-500" />
        <button
          type="button"
          className="flex-1 cursor-pointer text-left"
          title="Read in the AI viewer"
          onClick={() => bibleState.showStudyCommentary(study.aiCommentary!, study.readerThoughts)}
        >
          It is written… — <em>{study.aiCommentary.pericopeTitle}</em> attached; prints as the
          last page.
        </button>
        <button
          type="button"
          className="ai-commentary-cue-remove"
          title="Remove AI commentary"
          onClick={() => bibleState.updateEditingStudy({ aiCommentary: undefined })}
        >
          <CloseIcon className="h-3.5 w-3.5" />
        </button>
      </div>
    );
  }

  if (!study.startingLocation) return null;

  return (
    <button
      type="button"
      data-testid="ai-commentary-cue"
      className="ai-commentary-cue"
      onClick={() => bibleState.startPericopeStudyAt(study.startingLocation!)}
    >
      <SparklesIcon className="h-4 w-4 shrink-0 text-cyan-500" />
      <span>
        It is written… — add an AI commentary of this passage for your group to read and weigh
        together.
      </span>
    </button>
  );
});
